<!-- Screen & not undocked-->
@if ((expanded | async) && !isMobile) {
    <div class="parent-div rounded-lg p-2.5">
        <!--Icon if unpin button not clicked & sliding in/out of sidebar is not enabled-->
        <div class="flex" [ngClass]="{'hidden' : !(expanded | async)}">
            @if (sidebarListItem.ItemType != WorkspaceItemType.Separator) {
                <bizz-sidebar-link
                        [workspaceId]="workspaceId"
                        [sidebarListItem]="sidebarListItem"
                        [expanded]="expanded"
                        [newTableViewRecordLinkActive]="newTableViewRecordLinkActive"
                        [isMobile]="false"
                        (sidebarLinkClicked)="openLink(sidebarListItem);slideSidebar()">
                </bizz-sidebar-link>
            } @else {
                <!--Separator-->
                <div class="group flex gap-4 text-sidebar-header">
                    <bizz-icon class="mt-0.5 size-6 min-w-[1.25rem] text-sidebar-icon sm:size-5"
                               [iconLibrary]="sidebarListItem.Icon.Library"
                               [iconName]="sidebarListItem.Icon.Name">
                    </bizz-icon>
                    <p class="text-base no-underline sm:text-sm"
                       [ngClass]="{'max-h-64': !sidebarListItem.collapsed, 'overflow-hidden': !(expanded | async)}">
                        {{ sidebarListItem.Name }}
                    </p>
                </div>
            }
            @if (children && children.length > 0) {
                <ng-container>
                    <bizz-icon (click)="sidebarListItem.collapsed = !sidebarListItem.collapsed"
                               [hover]="true"
                               [iconName]="sidebarListItem.collapsed ? 'angle-down' : 'angle-up'"
                               class="ml-auto size-3.5 min-w-3.5 text-sidebar-icon hover:text-sidebar-link-hover">
                    </bizz-icon>
                </ng-container>
            }
        </div>
        <!--Show childeren of sidebar if sidebar is Docked-->
        @if (children && children.length > 0 && !sidebarListItem.collapsed) {
            <div class="ml-[2.27rem] mt-1.5 flex flex-col gap-1.5 font-medium">
                @for (child of children; track $index) {
                    <bizz-sidebar-link [isMobile]="false"
                                       [workspaceId]="workspaceId"
                                       [isChild]="true"
                                       [workspaceSidebarItem]="child"
                                       [expanded]="expanded"
                                       [newTableViewRecordLinkActive]="newTableViewRecordLinkActive"
                                       (sidebarLinkClicked)="openLink(child);slideSidebar()">

                    </bizz-sidebar-link>
                }
            </div>
        }
    </div>
} @else if (isMobile) {
    <!-- Mobile -->
    <div class="parent-div text-title mx-4 box-border flex flex-col rounded-lg p-2.5">
        <div class="flex flex-row">
            @if (sidebarListItem.ItemType == WorkspaceItemType.Separator) {
                <div class="group flex flex-row gap-4 text-sidebar-header">
                    <bizz-icon
                            [iconLibrary]="sidebarListItem.Icon.Library"
                            [iconName]="sidebarListItem.Icon.Name"
                            class="size-6 min-w-6 text-sidebar-icon">
                    </bizz-icon>
                    <p class="text-md max-w-[10.74rem] text-sidebar-header no-underline">
                        {{ sidebarListItem.Name }}
                    </p>
                </div>

            } @else {
                <bizz-sidebar-link
                        [workspaceId]="workspaceId"
                        [sidebarListItem]="sidebarListItem"
                        [expanded]="expanded"
                        [newTableViewRecordLinkActive]="newTableViewRecordLinkActive"
                        [isMobile]="true"
                        (sidebarLinkClicked)="openLink(sidebarListItem);slideSidebar()">
                </bizz-sidebar-link>
            }
            @if (children && children.length > 0) {
                <ng-container>
                    <bizz-icon (click)="sidebarListItem.collapsed = !sidebarListItem.collapsed"
                               [hover]="true"
                               [iconName]="sidebarListItem.collapsed ? 'angle-down' : 'angle-up'"
                               class="ml-auto size-5 min-w-5 text-sidebar-header hover:text-sidebar-link-hover">
                    </bizz-icon>
                </ng-container>
            }
        </div>

        @if (children && children.length > 0 && !sidebarListItem.collapsed) {
            <div class="mt-1.5 flex flex-col gap-1.5 font-medium">
                @for (child of children; track $index) {
                    <bizz-sidebar-link [isMobile]="true"
                                       [workspaceId]="workspaceId"
                                       [isChild]="true"
                                       [workspaceSidebarItem]="child"
                                       [expanded]="expanded"
                                       [newTableViewRecordLinkActive]="newTableViewRecordLinkActive"
                                       (sidebarLinkClicked)="openLink(child);slideSidebar()">
                    </bizz-sidebar-link>
                }
            </div>
        }

    </div>
} @else {
    <!-- Screen Icon if unpin button clicked & sliding in/out of sidebar gets enabled -->
    <bizz-icon class="flex h-6 w-6 text-sidebar-icon hover:text-sidebar-link-hover"
               [iconLibrary]="sidebarListItem.Icon.Library" [iconName]="sidebarListItem.Icon.Name" [hover]="true">
    </bizz-icon>
}